import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../utils/adminApi";
import "./Brand.css";

import appleLogo from "../assets/apple1.svg";
import googleLogo from "../assets/google-pixel-1.svg";
import motorolaLogo from "../assets/motorola.svg";
import oneplusLogo from "../assets/oneplus-2.svg";
import oppoLogo from "../assets/oppo.svg";
import realmeLogo from "../assets/realme-logo (1).svg";
import vivoLogo from "../assets/vivo.svg";
import xiaomiLogo from "../assets/xiaomi-1.svg";

const brandLogos = {
  apple: appleLogo,
  "google pixel": googleLogo,
  google: googleLogo,
  pixel: googleLogo,
  motorola: motorolaLogo,
  oneplus: oneplusLogo,
  "one plus": oneplusLogo,
  oppo: oppoLogo,
  realme: realmeLogo,
  vivo: vivoLogo,
  xiaomi: xiaomiLogo,
  mi: xiaomiLogo,
  redmi: xiaomiLogo,
};

const buildFallbackLogo = (name = "") => {
  const letter = (name.trim()[0] || "B").toUpperCase();
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='140' height='140'>
    <rect width='140' height='140' rx='28' fill='#0f172a'/>
    <text x='70' y='90' text-anchor='middle'
      font-size='64' font-family='Arial' fill='#ffffff'>
      ${letter}
    </text>
  </svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};

const getMappedLogo = (brandName = "") =>
  brandLogos[brandName.trim().toLowerCase()] || null;

const getImageSrc = (value = "") => {
  const src = String(value || "").trim();
  if (!src) return "";
  if (src.startsWith("data:") || src.startsWith("http")) return src;
  return `${API_BASE_URL}/${src.replace(/^\/+/, "")}`;
};

const Brands = () => {
  const navigate = useNavigate();
  const [brands, setBrands] = useState(null);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/brands`);

        // 🔥 Sort brands A → Z here
        const sortedBrands = (Array.isArray(res.data) ? res.data : [])
          .sort((a, b) =>
            a.name.localeCompare(b.name, undefined, {
              sensitivity: "base",
            })
          );

        setBrands(sortedBrands);
      } catch (error) {
        console.error("Error fetching brands:", error);
        setBrands([]);
      }
    };

    fetchBrands();
  }, []);

  return (
    <div className="brand-page-wrapper">
      <h1>
        Select your <span>Brand</span>
      </h1>

      {brands && (
        <div className="brand-bento-grid">
          {brands.length === 0 && (
            <p className="no-results">
              {/* No brands found. Please add brands from admin panel. */}
            </p>
          )}

          {brands.map((brand, index) => (
            <div
              key={brand._id}
              className="brand-card-premium"
              style={{ "--index": index }}
              onClick={() =>
                navigate(`/models/${encodeURIComponent(brand.name)}`)
              }
            >
              <div className="card-content">
                <div className="brand-visual">
                  <img
                    src={
                      brand.logo
                        ? getImageSrc(brand.logo)
                        : getMappedLogo(brand.name) ||
                          buildFallbackLogo(brand.name)
                    }
                    alt={brand.name}
                  />
                </div>

                <div className="brand-details">
                  <h3>{brand.name}</h3>
                  <p>Device Collection</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Brands;
